import { delay, unionWith, differenceWith, isEqual } from 'lodash';
var Timer = /** @class */ (function () {
    function Timer(_callback, _delay) {
        this._callback = _callback;
        this._delay = _delay;
        this._start = Date.now();
        this._id = null;
        this.resume();
    }
    Timer.create = function (callback, _delay) {
        return new Timer(callback, _delay);
    };
    Timer.prototype.pause = function () {
        this.stop();
        this._delay -= Date.now() - this._start;
    };
    Timer.prototype.resume = function () {
        this._start = Date.now();
        this.stop();
        this._id = delay(this._callback, this._delay);
    };
    Timer.prototype.stop = function () {
        if (this._id) {
            clearTimeout(this._id);
            this._id = null;
        }
    };
    return Timer;
}());
export { Timer };
var Interval = /** @class */ (function () {
    function Interval(_callback, _delay) {
        this._callback = _callback;
        this._delay = _delay;
        this._id = null;
        this.resume();
    }
    Interval.prototype.pause = function () {
        this.stop();
    };
    Interval.prototype.resume = function () {
        this.stop();
        this._id = setInterval(this._callback, this._delay);
    };
    Interval.prototype.stop = function () {
        if (this._id) {
            clearInterval(this._id);
            this._id = null;
        }
    };
    return Interval;
}());
export { Interval };
export function sleep(ms) {
    if (ms === void 0) { ms = 0; }
    return new Promise(function (r) { return setTimeout(r, ms); });
}
export function merge(a, b) {
    return unionWith(a, b, isEqual);
}
export function difference(a, b) {
    return differenceWith(a, b, isEqual);
}
//# sourceMappingURL=JiveSessionUtils.js.map